import { render, staticRenderFns } from "./LoginTfa.vue?vue&type=template&id=6047fc9a&scoped=true&"
import script from "./LoginTfa.vue?vue&type=script&lang=js&"
export * from "./LoginTfa.vue?vue&type=script&lang=js&"
import style0 from "./LoginTfa.vue?vue&type=style&index=0&id=6047fc9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047fc9a",
  null
  
)

export default component.exports